import Parse from 'parse';

import {
  DeprecateAlgorithmHandler,
  UpdateAlgorithmMetadataHandler,
  UpdatePipelineAlgorithmHandler,
} from '@protocols/use-cases';
import {
  ALGORITHM_FACADE_LIST_ALGORITHM_USAGE_HANDLER,
  ALGORITHM_FACADE_PIPELINE_REPOSITORY,
  ALGORITHM_FACADE_UPDATE_ALGORITHM_METADATA_HANDLER,
  ALGORITHM_FACADE_UPDATE_PIPELINE_ALGORITHM_HANDLER,
  ALGORITHM_FACADE_DEPRECATE_ALGORITHM_HANDLER,
  AlgorithmsFacade,
} from './algorithms.facade';
import {
  ListAlgorithmUsageHandler,
  ParseAlgorithmRepository,
  ParsePipelineRepository,
} from '@telespot/infrastructure/parse';
import { type AlgorithmRepository, type PipelineRepository } from '@telespot/domain';
import { InjectionToken, Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import { algorithmStoreProviders } from '../../../providers/store.providers';

const FACADE_ALGORITHM_REPOSITORY = new InjectionToken<AlgorithmRepository>('FACADE_ALGORITHM_REPOSITORY');

export const algorithmFacadeProviders: Provider[] = [
  ...algorithmStoreProviders(PaginatedStateLoadingMode.PAGINATED),
  {
    provide: FACADE_ALGORITHM_REPOSITORY,
    useFactory: () => new ParseAlgorithmRepository(Parse, { useMasterKey: false }),
  },
  {
    provide: ALGORITHM_FACADE_PIPELINE_REPOSITORY,
    useFactory: () => new ParsePipelineRepository(Parse, { useMasterKey: false }),
  },
  {
    provide: ALGORITHM_FACADE_LIST_ALGORITHM_USAGE_HANDLER,
    useFactory: () => new ListAlgorithmUsageHandler(),
  },
  {
    provide: ALGORITHM_FACADE_UPDATE_PIPELINE_ALGORITHM_HANDLER,
    useFactory: (pipelineRepository: PipelineRepository, algorithmRepository: AlgorithmRepository) =>
      new UpdatePipelineAlgorithmHandler(pipelineRepository, algorithmRepository),
    deps: [ALGORITHM_FACADE_PIPELINE_REPOSITORY, FACADE_ALGORITHM_REPOSITORY],
  },
  {
    provide: ALGORITHM_FACADE_DEPRECATE_ALGORITHM_HANDLER,
    useFactory: (algorithmRepository: AlgorithmRepository) => new DeprecateAlgorithmHandler(algorithmRepository),
    deps: [FACADE_ALGORITHM_REPOSITORY],
  },
  {
    provide: ALGORITHM_FACADE_UPDATE_ALGORITHM_METADATA_HANDLER,
    useFactory: (algorithmRepository: AlgorithmRepository) => new UpdateAlgorithmMetadataHandler(algorithmRepository),
    deps: [FACADE_ALGORITHM_REPOSITORY],
  },
  AlgorithmsFacade,
];
